// extracted by mini-css-extract-plugin
module.exports = {"homePage":"Home_homePage__2KKGh","fadeInAnimation":"Home_fadeInAnimation__28wWf"};